
import React from "react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

const WedgingScoreButtons: React.FC<{ onScoreChange: (score: number) => void }> = ({ onScoreChange }) => {
  const { t } = useTranslation('training');

  return (
    <div className="grid grid-cols-1 gap-2">
      <Button 
        className="h-14 bg-green-600 hover:bg-green-700 text-white border-0 text-base font-medium" 
        onClick={() => onScoreChange(4)}
      >
        {t('level1.scoring.wedging.ballIn')} (4 pts)
      </Button>
      <Button 
        className="h-14 bg-green-500 hover:bg-green-600 text-white border-0 text-base font-medium" 
        onClick={() => onScoreChange(3)}
      >
        {t('level1.scoring.wedging.safeZone09')} (3 pts)
      </Button>
      <Button 
        className="h-14 bg-yellow-500 hover:bg-yellow-600 text-white border-0 text-base font-medium" 
        onClick={() => onScoreChange(2)}
      >
        {t('level1.scoring.wedging.at3m')} (2 pts)
      </Button>
      <Button 
        className="h-14 bg-yellow-600 hover:bg-yellow-700 text-white border-0 text-base font-medium" 
        onClick={() => onScoreChange(1)}
      >
        {t('level1.scoring.wedging.at5m')} (1 pt)
      </Button>
      <Button 
        className="h-14 bg-red-500 hover:bg-red-600 text-white border-0 text-base font-medium" 
        onClick={() => onScoreChange(0)}
      >
        {t('level1.scoring.wedging.outsideCircles')} (0 pt)
      </Button>
    </div>
  );
};

export default WedgingScoreButtons;
